const { optionLabel, } = require('../lib/consolidationAccountItems');

const fields = ({ accountItems = [], }) => {
  return {
    accountItemIds: {
      label: '取込む科目',
      type: 'multiSelect',
      options: accountItems.map(_ => ({ label: optionLabel(_), value: _.id })),
    },
  };
};

exports.fields = fields;
